import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import { bankList } from '../../Utils/bankList';

import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';
import BankDefaultImage from '../../image/BankDefault.svg';

export default function BankSelectBox(props) {
  const { selectedBank, setSelectedBank, disabled } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isOpen, setIsOpen] = useState(false);

  const DropdownRef = useRef(null);

  // 외부 클릭 시 드롭다운 닫기 //
  useEffect(() => {
    function onClickOutside(e) {
      if (DropdownRef.current && !DropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  // 셀렉터 클릭 - 드롭다운 토글 //
  function onClickToggle() {
    if (disabled) return;

    setIsOpen(prev => !prev);
  }

  // 은행 항목 클릭 - 선택 후 드롭다운 닫기 //
  function onClickBank(bank) {
    setSelectedBank(bank);
    setIsOpen(false);
  }

  return (
    <Selector ref={DropdownRef}>
      <SelectorButton
        $disabled={disabled}
        borderColor={theme.line}
        backgroundColor={theme.subBackground}
        onClick={onClickToggle}>
        <LogoImage src={selectedBank?.logo || BankDefaultImage} alt={selectedBank?.name || ''} />
        <ArrowWrapper $isOpen={isOpen} arrowColor={theme.line}>
          <LeftArrowSvg width={12} height={12} />
        </ArrowWrapper>
      </SelectorButton>
      {
        isOpen && !disabled &&
        <Dropdown
          borderColor={theme.line}
          backgroundColor={theme.subBackground}
          scrollBarColor={theme.scrollBar}>
          {bankList.map((bank, index) => (
            <DropdownItem
              key={'BankItem-' + index}
              hoverColor={theme.buttonFill}
              hoverTextColor={theme.primary}
              onClick={() => onClickBank(bank)}>
              <LogoImage src={bank.logo} alt={bank.name} />
              <BankNameText color={selectedBank?.name === bank.name ? theme.primary : theme.text}>
                {bank.name}
              </BankNameText>
            </DropdownItem>
          ))}
        </Dropdown>
      }
    </Selector>
  );
}

const Selector = styled.div`
  position: relative;

  flex-shrink: 0;
`;

const SelectorButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 70px;
  height: 32px;

  padding: 5px;
  box-sizing: border-box;

  border-radius: 5px;
  border: 1px solid ${props => props.borderColor};
  background-color: ${props => props.backgroundColor};

  cursor: ${props => props.$disabled ? 'default' : 'pointer'};
  opacity: ${props => props.$disabled ? 0.4 : 1};

  transition: opacity 0.3s ease-in-out;
`;

const LogoImage = styled.img`
  width: 32px;
  height: 23px;

  object-fit: contain;

  flex-shrink: 0;
`;

const ArrowWrapper = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 23px;
  height: 24px;

  transform: ${props => props.$isOpen ? 'rotate(90deg)' : 'rotate(-90deg)'};
  transition: transform 0.2s ease-in-out;

  & path {
    fill: ${props => props.arrowColor};
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;

  display: flex;
  flex-direction: column;

  width: 253px;
  max-height: 300px;
  overflow-y: auto;

  border-radius: 8px;
  border: 1px solid ${props => props.borderColor};
  background-color: ${props => props.backgroundColor};

  z-index: 100;

  scrollbar-width: thin;
  scrollbar-color: ${props => props.scrollBarColor} transparent;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.scrollBarColor};

    border-radius: 50px;
  }

  &::-webkit-scrollbar-track {
    margin: 4px 0;

    background-color: transparent;

    border-radius: 300px;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
`;

const DropdownItem = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;

  width: 100%;
  height: 35px;

  padding: 6px 15px;
  box-sizing: border-box;

  flex-shrink: 0;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.hoverColor};
    }

    &:hover p {
      color: ${props => props.hoverTextColor};
    }
  }
`;

const BankNameText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
